import { component, prop, action, getter } from '../../decorators';

import { ADD_TO_CART } from '../../store/actions';

import ClipPlayer from '../common/clip-player/clip-player.vue';
import Tag from '../common/tag/tag.vue';
import MetadataInfo from '../common/metadata-info/metadata-info.vue';
import AddToCart from '../add-to-cart/add-to-cart.vue';

import groupBy from 'lodash/groupBy';
import reduce from 'lodash/reduce';
import has from 'lodash/has';

import { source } from '../../mixins/player.sources.mixin';

import { metadata } from '../../helpers/clip.helpers';
import l10n from '../../transformers/l10n';
import { METADATA_TYPES } from '../../config';

const TYPES = METADATA_TYPES.filter(mt => mt.type !== 'character');

@component({
   components: { ClipPlayer, AddToCart, Tag, MetadataInfo },
   watch: {
      clip: 'init'
   }
})
export default class ClipDetails {
   @prop({ type: Object, required: true }) episode
   @prop({ type: Object, required: true }) clip
   @prop({ type: Array, required: true }) metadata
   @prop({ type: Array, required: true }) timedata

   characters = []
   groupedMetadata = []
   sources = null

   @action(ADD_TO_CART) addToCart
   @getter() getCurrentShowId

   init() {
      this.sources = null;
      const { tcIn, tcOut } = this.clip;

      const list = metadata(tcIn, tcOut, this.metadata, this.timedata);
      const data = groupBy(list, 'type');
      this.characters = data.character || [];

      this.groupedMetadata = reduce(TYPES, (memo, {type, tk}) => {
         if ( has(data, type) ) {
            memo.push({ type, label: l10n(tk), types: data[type] });
         }
         return memo;
      }, []);

      this.$nextTick(() => this.sources = source(this.clip) );
   }

   async addTo(cart) {
      const clip = this.clip;
      await this.addToCart({ cart, clip });
   }

   openClipMaker() {
      const { clip } = this;
      const query = clip ? { cid: clip.id } : {};
      const params = { mid: this.getCurrentShowId, eid: this.episode.id };
      this.$router.push({ name: 'ClipMaker', params, query });
      this.$emit('open-clip-maker');
   }

   mounted() {
      this.init();
   }
}
